"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageState = exports.MessageWaitAcceptCmd = exports.MessageResultEvent = exports.RoomState = void 0;
var RoomState;
(function (RoomState) {
    /**
     * 初始化状态
     */
    RoomState["INIT"] = "INIT";
    /**
     * 连接中，对应以前 CONNECTING
     */
    RoomState["CONNECTING"] = "CONNECTING";
    /**
     * 房间已打开，该状态可以发送消息
     */
    RoomState["OPENED"] = "OPENED";
    /**
     * 离线close后， 重连中，对应以前 RECONNECTING，此状态为离线状态
     */
    RoomState["RECONNECTING_IN_CLOSED"] = "RECONNECTING_In_CLOSED";
    /**
     * 断开链接,（房间断开链接，底层不再重连）
     */
    RoomState["SHUTDOWN"] = "SHUTDOWN";
})(RoomState || (RoomState = {}));
exports.RoomState = RoomState;
var MessageResultEvent;
(function (MessageResultEvent) {
    MessageResultEvent["ON_POST"] = "onpost";
    MessageResultEvent["NET_STATUS_CHANGE"] = "netStatusChange";
    MessageResultEvent["ON_SEND_ACCEPT"] = "onsendAccept";
})(MessageResultEvent || (MessageResultEvent = {}));
exports.MessageResultEvent = MessageResultEvent;
var MessageWaitAcceptCmd;
(function (MessageWaitAcceptCmd) {
    MessageWaitAcceptCmd["ACCEPT_COMMIT"] = "ACCEPT_COMMIT";
    MessageWaitAcceptCmd["COMMIT_ERROR"] = "COMMIT_ERROR";
    MessageWaitAcceptCmd["TASK_DUPLICATE"] = "TASK_DUPLICATE";
})(MessageWaitAcceptCmd || (MessageWaitAcceptCmd = {}));
exports.MessageWaitAcceptCmd = MessageWaitAcceptCmd;
var MessageState;
(function (MessageState) {
    MessageState["UNKNOWN"] = "unknown";
    MessageState["SENDING"] = "sending";
    MessageState["WAITING"] = "waiting";
    MessageState["WAIT_ACCEPT"] = "waitAccept";
})(MessageState || (MessageState = {}));
exports.MessageState = MessageState;
